import * as React from 'react';
import * as styles from './styles.css';

import { ArticleParagraph2, ArticleHeading4, Responsive } from '@cian/ui-kit';
import { WorkHonestly } from '../WorkHonestly';
import { AgentType, RgrCertificate } from '../RgrCertificate';
import { KokonTooltipIcon } from '../KokonTooltipIcon';
import { IAgencySchema } from '../../repositories/agent-catalog-search/entities/agency/AgencySchema';

export interface IAgencyCardProps {
  previewImg: React.ReactNode;
  age: string;
  agentId: number;
  name: string;
  offersCount: string;
  services: string;
  onClick(): void;
  levelNumber?: number | null;
  levelName?: string | null;
  hasRgrParticipation: IAgencySchema['hasRgrParticipation'];
  hasKokonParticipation: IAgencySchema['hasKokonParticipation'];
}

export function AgencyCard({
  previewImg,
  age,
  name,
  offersCount,
  services,
  onClick,
  levelName,
  levelNumber,
  hasRgrParticipation,
  hasKokonParticipation,
}: IAgencyCardProps) {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['one-column']}>
        <div className={styles['img']}>{previewImg}</div>
        <div className={styles['text-info']}>
          <div>
            <div className={styles['name']}>
              <span>{name}</span>
              <WorkHonestly levelNumber={levelNumber} levelName={levelName} />
              {hasRgrParticipation && <RgrCertificate type={AgentType.Agency} />}
              {hasKokonParticipation && <KokonTooltipIcon />}
            </div>
          </div>
          <div>
            <ArticleParagraph2 color="black_60">{age}</ArticleParagraph2>
          </div>
        </div>
      </div>
      <div className={styles['two-column']}>
        <Responsive desktop>
          <div className={styles['services']}>
            <ArticleParagraph2>{services}</ArticleParagraph2>
          </div>
        </Responsive>
        <div className={styles['work']}>
          <div>
            <ArticleHeading4>{offersCount}</ArticleHeading4>
          </div>
          <div>
            <ArticleParagraph2 color="black_60">в работе</ArticleParagraph2>
          </div>
        </div>
      </div>
    </div>
  );
}
